import { defineMessages } from 'react-intl'

export default defineMessages({
  saveStepTitle: {
    id: 'SpaceAppBuilderFeaturesPage.saveTitle',
    defaultMessage: 'Save Step'
  },
  saveStepDescription: {
    id: 'SpaceAppBuilderFeaturesPage.saveStepDescription',
    defaultMessage: 'You have unsaved changes. Would you like to save and proceed?'
  },
  saveClose: {
    id: 'SpaceAppBuilderFeaturesPage.saveClose',
    defaultMessage: 'Save & Close'
  },
  continueEditing: {
    id: 'SpaceAppBuilderFeaturesPage.continueEditing',
    defaultMessage: 'Continue editing'
  }
})
